import { gql } from '__generated__';

export default gql(`
  mutation SortProducts($input: SortProductsInput!) {
    sortProducts(input: $input) {
      id
      products {
        id
      }
    }
  }
`);
